/** @module ChangeTracking/DetailedView */
define([
	"react",
	"react-dom/client",
	"dojo/_base/declare",
	"dojo/on",
	"dojo/when",
	"csi/_base/storage",
	"csi/_base/underscore",
	"csi/constants",
	"csi/def",
	"csi/html",
	"csi/html/Widget",
	"csi/locale",
	"csi/service/rightPaneService",
	"csi/state/rootStore",
	"csi/store/UserNames",
	"csi/store/Values",
	"csi/types",
	"csi/user/UserAvatar",
	"csi/xml",
	"csi/xml/Query",
	"dojo/text!./DetailedView.html"
], function(React, ReactDom, declare, on, when, storage, _, {QRY_VALUE_ATTR, QRY_VALUE_RESOLVE_VALUE_REFS}, def, html, HtmlWidget, locale, {CHANGE_TRACKING_SLIM}, {rightPaneStore, routerStore}, UserNames, Values, types, {UserAvatar}, xml, Query, template) {

	var LOG_ENTRY = "ChangeLogEntry";
	var MODIFIED_BY_ATTR = "ModifiedBy";
	var CONTEXT_INSTANCE_CNL = "ContextInstanceCnl";
	var MODIFIED_QUERY_KEY = xml.queryKey("LogCurrentUser");

	return declare(HtmlWidget, {
		templateString: template,

		/**
		 * Store for "Modified By" values
		 */
		storeModifiedBy: null,

		postCreate: function() {
			this.btnCloseNode.setAttribute("title", locale.resource("LogDetailedClose", [routerStore.locationName]));
			this.inherited(arguments);
		},

		startup: function() {
			if (this._started) {
				return;
			}

			this._createTable();
			const res = this.inherited(arguments);

			when(UserNames.load(), () => {
				this._createModifiedByStore();

				var node = this.getViewNode();

				// Fill in "Summary" block
				var CT = types.formatTime(node.$CT, types.FORMAT_DATETIME); // Create Time
				html.text(this.createdOnNode, CT);

				var CR = UserNames.get(node.$CR); // Created By
				html.text(this.createdByNode, CR);

				var ModifiedAt = types.formatTime(node.$PT, types.FORMAT_DATETIME); // Modified Time (including system and admin users)
				html.text(this.ModifiedAtNode, ModifiedAt);

				var ModifiedBy = UserNames.get(node.$PB); // Modified By (including system and admin users)
				html.text(this.ModifiedByNode, ModifiedBy);

			});
			this.detailsExpanded = storage.get("LogDetailsExpanded");
			this._showDetails();
			return res;
		},

		_createTable: function() {
			var defType = def.typeDefinition("_CS_Site");
			var defView = defType.getViewDef("ChangeLog");

			this._insertView(defView, this.getViewNode()).then((view) => {
				view.placeAt(this.tableNode).startup();
				this._table = view;
			});
		},

		_createModifiedByStore: function() {
			const store = new Values({
				filterQuery: new Query()
					.Type(LOG_ENTRY)
					.RefAttr(CONTEXT_INSTANCE_CNL, xml.OP_EQUALS, this.urlRoot),
				requestModule: "ChangeTracking",
				requestOperation: "ChangeLogValuesByXML",
				requestParameters: {
					[QRY_VALUE_ATTR]: MODIFIED_BY_ATTR,
					[QRY_VALUE_RESOLVE_VALUE_REFS]: true,
				}
			});
			const cache = this.getCache();
			store.onResponse = (res) => {
				const options = {timestamp: new Date().getTime()};
				res.getNodes().forEach((item) => {
					cache.add(item, options);
				});
			}
			const {countProperty, idProperty} = store;
			const tbl = this._table;

			store.query().forEach((item) => {
				const count = item[countProperty];
				const cnl = item[idProperty];
				const userNode = cache.get(cnl);
				const value = userNode.$Name;
				const hint = locale.resource("LogUserChangesNumber") + " " + count;
				const div = html.create("div", {class: "csi-flex-row csi-flex-align-center"});
				const avatarDiv = html.create("div", {class: "csi-log-detailed-avatar"}, div);
				const a = html.a({innerText: value, title: hint}, div);

				this.own(on(a, "click", async () => {
					tbl.set("query", {});
					tbl.setQueryValue(MODIFIED_QUERY_KEY, value);
					await tbl.refreshData();
					tbl.postAction();
					return false;
				}));

				const root = ReactDom.createRoot(avatarDiv);
				root.render(React.createElement(UserAvatar, {user: userNode}, null));

				this.modifiedByContainerNode.appendChild(div)
			});
		},

		/**
		 * Close both Detailed view and Slim View
		 */
		_closeAll: function() {
			rightPaneStore.closeSelected();
		},

		/**
		 * Close Detailed view and open Slim View
		 */
		_collapseView: function() {
			rightPaneStore.setSelected(CHANGE_TRACKING_SLIM);
		},

		/**
		 * Toggle Expand/Collapse property of right info block, save property to local storage
		 */
		_collapse: function() {
			this.detailsExpanded = !this.detailsExpanded;
			storage.set("LogDetailsExpanded", this.detailsExpanded);
			this._showDetails();
		},

		/**
		 * Resize change log table
		 */
		_onResize: function() {
			this._table._onResize();
		},

		/**
		 * Show/hide right info block, update collapse button label accordingly
		 */
		_showDetails: function() {
			// toggle right block visibility by setting css class
			$(this.detailedViewNode).toggleClass("csi-log-detailed-right-hidden", !this.detailsExpanded);
			// Set material icon for collapse/expand icon
			html.setInnerText(this.btnExpandNode, this.detailsExpanded ? "keyboard_arrow_right" : "keyboard_arrow_left");
			this.resize();
		}
	});
});